import "./services.scss";

import NavBar from "../../components/NavBar.js";
import { getAuth } from "../../data-access/FirebaseAuth.js";
import { setupNavBar } from "../utils/setup.js";


//==================================================
// Code that must be added to each page that will utilize the
// NavBav web component.
let navbarElem = document.querySelector("nav-bar");
setupNavBar(navbarElem);
// End of Navbar related setup code.
//====================================================


function displayMapModal() {
    let mapModal = document.querySelector("#boundary-map-modal");
    mapModal.classList.add("is-active");
}
function removeMapModal() {
    let mapModal = document.querySelector("#boundary-map-modal");
    mapModal.classList.remove("is-active");
}

document.querySelector("#boundary-map-img").onclick = displayMapModal;
let mapModalBackground = document.querySelector('#boundary-map-modal-background');
mapModalBackground.onclick = removeMapModal;
let mapModalButton = document.querySelector('#close-map-modal');
mapModalButton.onclick = removeMapModal;